import { pushDataLayerBudgetEvent } from 'assets/core/js/page/product/search/filters/datalayer'
import budgetSlider from 'assets/core/js/page/search/budget-slider'
import submitFilterForm from './submit-filter-form'

export default function (): void {
  budgetSlider({
    callbackChange: (value: string) => {
      pushDataLayerBudgetEvent(value)

      submitFilterForm()
    },
  })
}
